import React from "react";
import { Row, Col, Space, Divider, Button, Popconfirm } from "antd";
import {
  PrinterOutlined,
  FileExcelOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";

/**
 * Button descriptors
 * ───────────────────
 * action      : "preview" | "export" | "restore" | "custom"
 * label     : string                (optional for built-ins)
 * icon      : ReactNode             (optional for built-ins)
 * onClick   : () => void            (built-ins can be auto-wired)
 * loading   : bool
 * disabled  : bool
 * confirm   : { title, okText, cancelText }  – wrap in Popconfirm
 * style     : object (inline style)
 */

const builtinMap = {
  preview: {
    icon: <PrinterOutlined />,
    label: "Preview",
    btnProps: { type: "primary", htmlType: "submit", id: "processButton" },
  },
  export: {
    icon: <FileExcelOutlined />,
    label: "Export",
  },
  restore: {
    icon: <UndoOutlined />,
    label: "Restore Default",
  },
};

const ReportPanelBottomBar = ({ buttons = [] }) => {
  const isFetching = useSelector((state) => state.report.isFetching);
  const isExporting = useSelector((state) => state.report.isExporting);

  const buildButton = (desc) => {
    const base = builtinMap[desc.action] || {};

    const {
      action,
      confirm,
      icon = base.icon,
      label = base.label,
      btnProps = base.btnProps,
      loading: loadingProp, // may be undefined
      ...rest
    } = desc;

    let loading = loadingProp;
    if (loading === undefined) {
      if (action === "preview") loading = isFetching;
      if (action === "export") loading = isExporting;
    }

    const btn = (
      <Button {...btnProps} {...rest} loading={loading}>
        {icon} {label}
      </Button>
    );

    return confirm ? <Popconfirm {...confirm}>{btn}</Popconfirm> : btn;
  };

  return (
    <Row justify="end">
      <Divider dashed style={{ marginTop: 16, marginBottom: 16 }} />
      <Col>
        <Space align="end">
          {buttons.map((b, i) => (
            <React.Fragment key={i}>{buildButton(b)}</React.Fragment>
          ))}
        </Space>
      </Col>
    </Row>
  );
};

export default ReportPanelBottomBar;
